import { PERMISSION_DENIED_ERROR_CODES } from '@wix/package-picker-shared';
import { useEclipsePanorama } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
export const useCheckoutInitError = () => {
  const panorama = useEclipsePanorama();
  const module = useCurrentModule();
  const {
    showNotification
  } = module.SDK.useNotification();
  const {
    t
  } = module.internals.useTranslations();
  const {
    bi
  } = module.internals;
  const handleInitError = (error, orderPageEventAggregator, errorInfo) => {
    var _response;
    bi.onCheckoutInitError == null || bi.onCheckoutInitError({
      failureReason: `${errorInfo == null ? void 0 : errorInfo.failureReason}: ${errorInfo == null ? void 0 : errorInfo.translatedErrorMessage}`,
      eventAggregator: orderPageEventAggregator
    });
    panorama.reportError(new Error((errorInfo == null ? void 0 : errorInfo.failureReason) || error.message), {
      errorInfo,
      error,
      orderPageEventAggregator
    });
    const errorCode = error == null || (_response = error.response) == null || (_response = _response.data) == null || (_response = _response.details) == null || (_response = _response.applicationError) == null ? void 0 : _response.code;
    const isPermissionsDeniedError = PERMISSION_DENIED_ERROR_CODES.includes(errorCode);
    if (isPermissionsDeniedError) {
      const messageKey = 'app.notification.initialization_permissions_error';
      showNotification({
        message: t(messageKey),
        onShow: () => {
          bi.onNotificationShow == null || bi.onNotificationShow({
            messageKey,
            step: 'checkout'
          });
        },
        onCloseClick: () => {
          bi.onNotificationClose == null || bi.onNotificationClose({});
        }
      });
    } else {
      const messageKey = 'app.notification.initialization_error';
      showNotification({
        message: (errorInfo == null ? void 0 : errorInfo.translatedErrorMessage) || t(messageKey),
        action: {
          text: t('app.notification.reload_page'),
          onClick: () => {
            bi.onNotificationClick == null || bi.onNotificationClick({
              action: 'reload_page'
            });
            window.location.reload();
          }
        },
        onShow: () => {
          bi.onNotificationShow == null || bi.onNotificationShow({
            messageKey,
            step: 'checkout'
          });
        },
        onCloseClick: () => {
          bi.onNotificationClose == null || bi.onNotificationClose({});
        }
      });
    }
  };
  return {
    handleInitError
  };
};
//# sourceMappingURL=useCheckoutInitError.js.map